import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=6643a742&scoped=true&"
import script from "./Subscriptions.vue?vue&type=script&lang=ts&"
export * from "./Subscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=6643a742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643a742",
  null
  
)

export default component.exports